import {
  COMPLIANCE_EMPLOYEE_DOCUMENT_STAGES_VALUES,
  DEFAULT_EMPLOYEE_DOCUMENT_STAGES_VALUES,
  EMPLOYEE_DOCUMENT_HR_TYPES,
  EMPLOYEE_DOCUMENT_SECTIONS,
  EMPLOYEE_DOCUMENT_STAGES_ALIAS,
  HR_EMPLOYEE_DOCUMENT_STAGES_VALUES,
} from './constants';

const isComplianceOrHrSpecialType = (section?: string, fileType?: string) =>
  section === EMPLOYEE_DOCUMENT_SECTIONS.COMPLIANCE ||
  (section === EMPLOYEE_DOCUMENT_SECTIONS.HR && fileType !== EMPLOYEE_DOCUMENT_HR_TYPES.OTHER);

export const getEmployeeDocumentStageOptions = (section?: string, fileType?: string) => {
  if (section === EMPLOYEE_DOCUMENT_SECTIONS.COMPLIANCE) {
    return COMPLIANCE_EMPLOYEE_DOCUMENT_STAGES_VALUES;
  }

  if (section === EMPLOYEE_DOCUMENT_SECTIONS.HR && fileType !== EMPLOYEE_DOCUMENT_HR_TYPES.OTHER) {
    return HR_EMPLOYEE_DOCUMENT_STAGES_VALUES;
  }

  return DEFAULT_EMPLOYEE_DOCUMENT_STAGES_VALUES;
};

export const getEmployeeDocumentDefaultStage = (section?: string, fileType?: string) =>
  isComplianceOrHrSpecialType(section, fileType) ? '' : EMPLOYEE_DOCUMENT_STAGES_ALIAS.UPLOADED;
